<template>
  <div class="body-container">
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        
      >
        <v-card-text>
         <div class="loadTitle">
        <img :src="images.logo" /> <label>Cargando...</label>
        </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <b-collapse
      class="card property show"
      animation="slide"
      aria-id="contentIdForA11y3"
      :open="isOpen"
    >
      <template #trigger="props">
        <div
          class="card-header"
          role="button"
          aria-controls="contentIdForA11y3"
        >
          <div class="property-title">
            <h3>
              <strong>Mi propiedad:</strong> {{ productoPrincipal.tipo }}
              {{ productoPrincipal.modelo }} Número
              {{ productoPrincipal.numero }}
            </h3>
          </div>
          <a class="card-header-icon">
            <font-awesome-icon v-if="props.open" :icon="['fa', 'chevron-up']" />
            <font-awesome-icon v-else :icon="['fa', 'chevron-down']" />
          </a>
        </div>
      </template>

      <div class="card-content">
        <div class="content">
          <div class="property-title">
            <h3><strong>N° de Negocio:</strong>{{ project.negocio }}</h3>
          </div>
          <div class="property-buttonsGroup">
            <router-link
              :to="{
                name: 'detalle',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'list']" />Detalles</router-link
            >
            <router-link
              :to="{
                name: 'estado-compra',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'home']" />Estado de
              Compra</router-link
            >
            <router-link
              :to="{
                name: 'avance-obra',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
              Obra</router-link
            >
            <router-link
              :to="{
                name: 'documentos',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'file']" />Documentos
              Negocio</router-link
            >
            <router-link
              :to="{ name: 'pagos', params: { idNegocio: project.idNegocio } }"
              ><font-awesome-icon
                :icon="['fa', 'dollar-sign']"
              />Pagos</router-link
            >
            <router-link
              :to="{
                name: 'documentos-propiedad',
                params: { idNegocio: project.idNegocio },
              }"
              ><font-awesome-icon :icon="['fa', 'map']" />Documentos
              Propiedad</router-link
            >
          </div>
          <b-button
            class="change-btn"
            @click="isCardModalActive = true"
            v-if="proyectos.length > 1"
            ><font-awesome-icon :icon="['fa', 'exchange-alt']" />Cambiar de
            Propiedad</b-button
          >
        </div>
      </div>
      <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
        <div class="card">
          <div class="card-content">
            <div class="misPropiedades-title">
              <h2><span class="bricsa-square"></span>Mis Propiedades</h2>
            </div>
            <div class="misPropiedades-content">
              <div
                class="misPropiedades-item"
                v-for="(misPro, index) in proyectos"
                :key="index"
              >
                <img :src="misPro.image" />
                <label
                  >{{ misPro.productoPrincipal.tipo }}
                  {{ misPro.productoPrincipal.numero }} -
                  {{ misPro.proyecto }}</label
                >
                <h6>
                  <router-link
                    :to="{
                      name: 'pagos',
                      params: { idNegocio: misPro.idNegocio },
                    }"
                    ><strong>N° de negocio:</strong> {{ misPro.negocio }}
                    <i class="far fa-eye"></i
                  ></router-link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </b-collapse>

    <section class="pagos">
      <div class="pagos-container">
        <div class="pagos-title">
          <h2><span class="bricsa-square"></span>Pagos</h2>
        </div>
        <div class="pagos-group">
          <div class="pagos-item pagos-title-desktop">
            <label class="pago-item__info-title">Fecha de Vencimiento</label>
            <label class="pago-item__info-title">Forma de financiamiento</label>
            <label class="pago-item__info-title">Concepto</label>
            <label class="pago-item__info-title">Estado</label>
            <label class="pago-item__info-title"> Monto</label>
          </div>
          <a class="pagos-item" v-for="pago in project.pagos" :key="pago.id">
            <div class="pago-item__info">
              <label class="pago-item__info-title">Fecha de Vencimiento</label>
              <label>{{ pago.fechaVencimiento | formatDate }}</label>
            </div>
            <div class="pago-item__info">
              <label class="pago-item__info-title"
                >Forma de financiamiento</label
              >
              <label>{{ pago.formaFinanciamiento }}</label>
            </div>
            <div class="pago-item__info">
              <label class="pago-item__info-title">Concepto</label>
              <label>{{ pago.concepto }}</label>
            </div>
            <div class="pago-item__info">
              <label class="pago-item__info-title">Estado</label>
              <label>{{ pago.estado }}</label>
            </div>
            <div class="pago-item__info">
              <label class="pago-item__info-title"> Monto</label>
              <h3>{{ pago.monto | currency }} <small>(UF {{ pago.montoUF | uf }})</small></h3>
            </div>
          </a>
        </div>
      </div>
    </section>
    <section class="texto-legal">
      <div class="texto-legal__info">
        <p>
          El estado de los pagos puede tener un desfase por motivos de
          validación. En caso que tengas alguna duda, puedes generar un
          requerimiento desde la sección “Ayuda” o comunicarte con nuestros
          ejecutivos.
        </p>
      </div>
    </section>

    <section class="masInfo">
      <div class="masInfo-title">
        <h2>
          <span class="bricsa-square"></span>Más información de tu propiedad
        </h2>
      </div>
      <div class="masInfo-tabs container">
        <router-link
          :to="{
            name: 'detalle',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'list']" />Detalles</router-link
        >
        <router-link
          :to="{
            name: 'estado-compra',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'home']" />Estado de
          Compra</router-link
        >
        <router-link
          :to="{
            name: 'avance-obra',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'hourglass-half']" />Avance
          Obra</router-link
        >
        <router-link
          :to="{
            name: 'documentos',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'file']" />Documentos
          Negocio</router-link
        >
        <router-link
          :to="{ name: 'pagos', params: { idNegocio: project.idNegocio } }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'dollar-sign']" />Pagos</router-link
        >
        <router-link
          :to="{
            name: 'documentos-propiedad',
            params: { idNegocio: project.idNegocio },
          }"
          class="masInfo-tabs__item"
          ><font-awesome-icon :icon="['fa', 'map']" />Documentos
          Propiedad</router-link
        >
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import {
  GET_PROJECTS,
  GET_PROJECT,
  GET_PROJECT_WP,
  GET_MODELO_WP,
} from "@/core/services/store/proyecto.module";
moment.locale("es");

export default {
  name: "index",
  components: {},
  data() {
    return {
      images: {
                family: process.env.BASE_URL + 'media/family.jpg',
                logo: process.env.BASE_URL +'media/logo.png',
            },
      loading: true,
      isOpen: false,
      isCardModalActive: false,
    };
  },
  mounted() {
    this.getProjects();
    this.getProject();
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.loading= true;
    this.$route.params.idNegocio = to.params.idNegocio;
    this.getProjects();
    this.getProject();
    this.isCardModalActive = false;
    next();
  },
  methods: {
    getProjects() {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECTS, null).then(() => {
        this.$Progress.finish();
        this.loading=false;
      });
    },
    getProject() {
      const idNegocio = this.$route.params.idNegocio;
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECT, idNegocio).then((response) => {
        const idProyecto = response.etapaNav.idProyecto;
        this.getProjectWp(idProyecto);
        this.getModeloWp();
        this.$Progress.finish();
      });
    },

    getProjectWp(sci) {
      this.$Progress.start();
      this.$store.dispatch(GET_PROJECT_WP, sci).then(() => {
        this.$Progress.finish();
      });
    },
    getModeloWp() {
      this.$Progress.start();
      this.$store
        .dispatch(GET_MODELO_WP, this.productoPrincipal.idModelo)
        .then(() => {
          this.$Progress.finish();
        });
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.agreement.errors,
      project: (state) => state.proyecto.project,
      project_wp: (state) => state.proyecto.project_wp,
      projects: (state) => state.proyecto.projects,
      modelo_wp: (state) => state.proyecto.modelo_wp,
      productoPrincipal: function () {
        if (typeof this.project.productos == "undefined") return {};
        let elementos = this.project.productos;
        return elementos.find((el) => {
          return el.esPrincipal == true;
        });
      },
      productos: function () {
        if (typeof this.project.productos == "undefined") return {};
        let elementos = this.project.productos;
        return elementos.find((el) => {
          return el.esPrincipal == false;
        });
      },
      destacados: function () {
        if (typeof this.novedades.contenidos == "undefined") return {};
        return this.novedades.contenidos.slice(0, 3);
      },
      proyectos: function () {
        if (typeof this.projects.proyectos == "undefined") return [];
        console.log(
          "  +++ " +
            typeof this.projects.proyectos +
            " " +
            this.projects.proyectos
        );
        let elementos = this.projects.proyectos;
        elementos.forEach((item) => {
          item.productoPrincipal = item.productos.find((el) => {
            return el.esPrincipal == true ?? {};
          });
        });
        return elementos;
      },
    }),
    patenteErrors() {
      const errors = [];
      if (!this.$v.form.patente) return errors;
      !this.$v.form.patente.required && errors.push("Patente es requerido");
      !this.$v.form.patente.patenteEsValido &&
        errors.push("Patente no es válida");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.property {
  position: absolute;
  padding: 0 6.5%;
  top: 130px;
  z-index: 99;
  width: 100%;
  height: fit-content;
  left: 0;
  background-color: #f5f5f5;
  @media screen and(max-width:1025px) {
    position: fixed;
    top: 119px;
  }
  .property-title {
    h3 {
      color: #4a4a4a;
      font-weight: normal;
      font-size: 16px;
      text-align: left;
    }
    strong {
      color: var(--bricsa-red);
      margin-right: 5px;
    }
  }

  .card-header {
    padding: 10px 24px 5px 19.5px;
    box-shadow: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f5f5;
    .card-header-icon {
      color: var(--bricsa-red);
    }
  }
  .card-content {
    padding-top: 0;
    .content {
      display: grid;
      row-gap: 10px;
    }
  }
  .modal {
    .card-content {
      .misPropiedades-title {
        h2 {
          color: #707070;
          font-size: 20px;
          font-weight: bold;
          text-align: left;
          margin: 10px;
          margin-left: 0;
          display: flex;
          align-items: baseline;
          span {
            display: block;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            background: var(--bricsa-red);
          }
        }
      }
      .misPropiedades-content {
        display: grid;
        grid-template-columns: repeat(2, 49%);
        justify-content: space-between;
        row-gap: 10px;
        .misPropiedades-item {
          text-align: left;
          font-size: 13px;
          strong {
            color: var(--bricsa-red);
          }
        }
      }
    }
  }
  .property-buttonsGroup {
    display: grid;
    grid-template-columns: repeat(6, calc(90% / 6));
    justify-content: space-between;
    row-gap: 10px;
    @media screen and(max-width:1025px) {
      grid-template-columns: repeat(3, 32%);
    }
    a {
      padding: 10px 15px;
      text-align: center;
      align-items: center;
      color: #7e7e7e;
      display: grid;
      grid-template-columns: 100%;
      justify-content: center;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      transition: 400ms;
      &:hover {
        background-color: #00457b;
        color: #fff;
      }
      @media screen and(max-width:1024px) {
        font-size: 12px;
      }
      @media screen and(max-width:426px) {
        padding: 5px;
      }
      svg {
        width: 100%;
        height: 30px;
        justify-self: center;
        color: #00457b;
        transition: 400ms;
        &:hover {
          color: #fff;
        }
        @media screen and(max-width:1024px) {
          height: 15px;
        }
      }
    }
  }
  .change-btn {
    background-color: var(--bricsa-red);
    border-radius: 0;
    border: none;
    color: #fff;
    justify-self: flex-end;
    font-size: 14px;
    svg {
      margin-right: 10px;
    }
  }
}

.pagos {
  width: 100%;
  min-width: 500px;
  @media screen and (max-width: 1024px) {
    min-width: 290px;
  }
  .pagos-container {
    width: 100%;
    .pagos-title {
      h2 {
        color: #707070;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        margin: 10px;
        margin-left: 0;
        display: flex;
        align-items: baseline;
        span {
          display: block;
          width: 15px;
          height: 15px;
          margin-right: 5px;
          background: var(--bricsa-red);
        }
      }
    }
    .pagos-group {
      width: 100%;
      display: grid;
      row-gap: 5px;
      @media screen and (max-width: 1024px) {
        width: 100%;
      }
      .pagos-title-desktop {
        display: block;
        @media screen and(max-width:660px) {
          display: none !important;
        }
      }
      .pagos-item {
        padding: 10px 20px;
        color: #707070;
        background: #e9e9e9;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(5, 19%);
        justify-content: space-between;
        align-items: center;
        @media screen and(max-width:660px) {
          grid-template-columns: 100%;
        }
        .pago-item__info {
          display: flex;
          justify-content: space-between;
          .pago-item__info-title {
            display: none;
            @media screen and(max-width:660px) {
              display: block;
            }
          }
        }
        .pago-item__info-title {
          font-weight: bold;
        }

        label {
          text-align: left;
        }
        a {
          color: #000;
          transition: 400ms;
          &:hover {
            color: var(--bricsa-red);
          }
        }
      }
    }
  }
}

.texto-legal {
  margin-top: 20px;
  padding: 20px;
  background: #cbcbcb;
  .texto-legal__info {
    p {
      font-style: italic;
    }
  }
}

.masInfo {
  .masInfo-title {
    h2 {
      color: #707070;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      margin: 10px;
      margin-left: 0;
      display: flex;
      align-items: baseline;
      span {
        display: block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background: var(--bricsa-red);
      }
    }
  }
  .masInfo-tabs {
    display: grid;
    grid-template-columns: repeat(6, 16%);
    justify-content: space-between;
    padding: 3% 5%;
    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(3, 32%);
    }
    .masInfo-tabs__item {
      font-size: 10px;
      padding: 10px;
      height: 100%;
      text-align: center;
      font-weight: bold;
      border: none;
      border-radius: 0px;
      -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      color: var(--bricsa-skiblue);
      align-items: center;
      svg {
        @media screen and (max-width: 769px) {
          height: 15px;
        }
      }
    }
  }
}
</style>